(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('printonary-collection-pagination')) {
    class PrintonaryCollectionPagination extends HTMLElement {
      static observedAttributes = ['data-last-page'];
      #observer;

      connectedCallback() {
        this.#observeGrid();
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
      }

      attributeChangedCallback() {
        if (this.isConnected) this.#observeGrid();
      }

      #observeGrid() {
        this.#observer?.disconnect();
        const grid = this.closest('results-list')?.querySelector('[ref="grid"]');
        if (!grid) return;
        this.#observer = new MutationObserver(() => this.#updateLinks(grid));
        this.#observer.observe(grid, { childList: true });
        this.#updateLinks(grid);
      }

      #updateLinks(grid) {
        const cards = Array.from(grid.querySelectorAll(':scope > [data-page]'));
        const pages = cards.map((card) => Number(card.dataset.page)).filter((page) => page > 0);
        if (!pages.length) return;

        const firstPage = Math.min(...pages);
        const lastPage = Math.max(...pages);
        const pageCount = Number(this.dataset.lastPage);
        const previous = this.querySelector('[data-pagination-previous]');
        const next = this.querySelector('[data-pagination-next]');
        if (!previous || !next) return;

        const pageUrl = (page) => {
          const url = new URL(window.location.href);
          url.searchParams.set(this.dataset.pageParam || 'page', String(page));
          url.hash = '';
          return url.pathname + url.search;
        };

        previous.hidden = firstPage <= 1;
        next.hidden = lastPage >= pageCount;
        if (!previous.hidden) previous.href = pageUrl(firstPage - 1);
        if (!next.hidden) next.href = pageUrl(lastPage + 1);
        this.hidden = previous.hidden && next.hidden;
      }
    }

    customElements.define('printonary-collection-pagination', PrintonaryCollectionPagination);
  }
  } catch(e) { console.error(e); }
})();

})();
